import axios from 'axios';

// Add a config for API selection
export type CleaningAPI = 'deepseek' | 'gemini';

const GEMINI_API_KEY = 'AIzaSyB1fKJs6uOGcVNBmfFYytr7Afjf-b27Bew';

// Add delay between requests
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

async function cleanWithGemini(text: string, retryCount = 0): Promise<string> {
  const url = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=' + GEMINI_API_KEY;
  const prompt = `Remove all non-main content (page numbers, headers, footers, copyright, etc.) and format this text for digital reading.\nPreserve all paragraph breaks and special formatting (like poetry or plays).\nDo not add any introductory or summary phrases.\nReturn only the cleaned and formatted book content, as a single block of text with multiple paragraphs.\n\nText:\n${text}`;
  
  try {
    // Add delay between requests to avoid rate limiting
    if (retryCount > 0) {
      await delay(1000 * retryCount); // Exponential backoff
    }
    
    const response: any = await axios.post(url, {
      contents: [{ parts: [{ text: prompt }] }]
    });
    
    return response.data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
  } catch (err: any) {
    console.error('Gemini API error:', err);
    
    // Handle rate limiting
    if (err.response?.status === 429 && retryCount < 3) {
      console.log(`Rate limited, retrying in ${retryCount + 1} seconds...`);
      return cleanWithGemini(text, retryCount + 1);
    }
    
    // If we've exhausted retries or it's a different error, return the original text
    console.warn('Failed to clean with Gemini, returning original text');
    return text;
  }
}

export async function cleanAndFormatTextWithClaude(text: string, model: CleaningAPI = 'deepseek'): Promise<string> {
  if (model === 'gemini') {
    return cleanWithGemini(text);
  }
  return text;
} 